import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#222",
      d: "M5 21q-.825 0-1.413-.588A1.92 1.92 0 0 1 3 19V5q0-.825.588-1.413A1.92 1.92 0 0 1 5 3h14q.825 0 1.413.588T21 5v14q0 .825-.588 1.413A1.92 1.92 0 0 1 19 21zm0-2h14V5H5zm2-2h10q.3 0 .45-.275a.44.44 0 0 0-.05-.525l-2.75-3.675a.48.48 0 0 0-.4-.2q-.25 0-.4.2L11.25 16 9.4 13.525a.48.48 0 0 0-.4-.2q-.25 0-.4.2l-2 2.675a.44.44 0 0 0-.05.525Q6.7 17 7 17m1.5-7q.625 0 1.063-.438T10 8.5q0-.625-.438-1.063A1.44 1.44 0 0 0 8.5 7q-.625 0-1.063.438A1.44 1.44 0 0 0 7 8.5q0 .625.438 1.063T8.5 10"
    }, null, -1)
  ]))]))
}
export default { render: render }